import { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import HandleChange from './../../../../../Helpers/HandleChange';
import { DEPARTMENT_MODEL, MEAL_TIME_MODEL, MENU_MODEL } from '../Model/Model';
import { useEffect } from 'react';
import {
    GetAllCourseType,
    GetAllItem,
    GetAllMeals,
    GetAllMealTimes,
    CreateMenu,
} from '../../../../../reduxToolkit/FoodieMenu/MenuApi';
import routes from '../../../../../Routes/routes';
import { toast } from 'react-toastify';
import { GetAllCafeterias } from '../../../../../reduxToolkit/FoodieShift/FoodieShiftApi';
import { errorMsg, DECIMAL_REGEX } from '../../../../../Apis/functions';
import { toMilitaryHour } from '../../../../../utils/TimeConversion';
import { GetFirstFoodieSetting } from '../../../../../reduxToolkit/Foodie/FoodieApi';
import {
    GetDepartmentsByCafeteriaId,
    GetUsersByCafeteriaId,
} from '../../../../../reduxToolkit/FoodieCafeteria/CafeteriaApi';
import {MIN_MEAL_COST} from "../../Manage/Models/Model";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

const CreateMenuApp = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    let { state } = location;
    const { allCourseType } = useSelector((state) => state.MenuSlice);
    const { allMeals } = useSelector((state) => state.MenuSlice);
    const { allCafeterias } = useSelector((state) => state.FoodieShiftSlice);
    const { allItem } = useSelector((state) => state.MenuSlice);
    const { allMealTimes } = useSelector((state) => state.MenuSlice);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const { getFirstFoodieSetting } = useSelector((state) => state.employeeFoodieSlice);
    const { getDepartmentsByCafeteriaId } = useSelector((state) => state.CafeteriaSlice);
    const { getUsersByCafeteriaId } = useSelector((state) => state.CafeteriaSlice);

    const [activeStep, setActiveStep] = useState(0);
    const [steps, setSteps] = useState([]);
    const [item, setItem] = useState({ ...MENU_MODEL });
    const [errorCode, setErrorCode] = useState(true);
    const [disabled, setDisabled] = useState(false);
    const [emptyFields, setEmptyFields] = useState({});
    const [selectedMealTime, setSelectedMealTime] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [mealTime, setMealTime] = useState(MEAL_TIME_MODEL);
    const [costInfo, setCostInfo] = useState(false);
    const [isServingDateValid, setIsServingDateValid] = useState(true);
    const [department, setDepartment] = useState(DEPARTMENT_MODEL);
    const [notAdded, setNotAdded] = useState(false);
    const [notSelected, setNotSelected] = useState(false);
    const [isValidCost, setIsValidCost] = useState(true);
    const [isValidCostText, setIsValidCostText] = useState('this_value_must_be_greater_than_0');
    const showCostInfo =  costInfo?.isBaseCost === false && costInfo?.isMealTimeCost === false;

    //validate id cafeteria serving date is valid
    useEffect(() => {
        if (item.cafeteriaServingDate && item.releaseDate) {
            setIsServingDateValid(new Date(item.cafeteriaServingDate) >= new Date(item.releaseDate));
        }
    }, [item.cafeteriaServingDate, item.releaseDate]);

    const { handleChange } = HandleChange({ model: item, setModel: setItem });

    /**
     * Validates the value entered in the cost input field.
     * If the cost is a base cost, no validation is applied.
     * Allows empty values and checks that the value is numeric and greater than zero.
     *
     * @param {Event} e Input event containing the value to be validated.
     */
    const validateCost = (e) => {
        if (!showCostInfo) return;
        const rawValue = e.target.value;
        if (rawValue === '') {
            setIsValidCost(true);
            return;
        }
        if (!DECIMAL_REGEX.test(rawValue)) {
            setIsValidCostText('invalid_format');
            setIsValidCost(false);
            return;
        }
        const value = Number(rawValue);
        setIsValidCostText('this_value_must_be_greater_than_0');
        setIsValidCost(!isNaN(value) && value > MIN_MEAL_COST.min);
    };

    // Define dependencies for each step to validate required fields
    const stepDependencies = {
        0: [item.dish, item.mealType, item.diner, selectedMealTime],
        1: [item.courseType, selectedDepartment],
        2: [selectedUsers],
    };

    // Initial data loading when component mounts
    useEffect(() => {
        dispatch(GetAllCourseType());
        dispatch(GetAllMeals());
        dispatch(GetAllMealTimes());
        dispatch(GetAllItem());
        dispatch(GetAllCafeterias());
        dispatch(GetFirstFoodieSetting());
    }, []);

    useEffect(() => {
        if (item.diner) {
            dispatch(GetDepartmentsByCafeteriaId(item.diner));
            dispatch(GetUsersByCafeteriaId(item.diner));
            dispatch(GetAllMealTimes());
        }
    }, [item.diner]);

    useEffect(() => {
        if (getFirstFoodieSetting) {
            setCostInfo(getFirstFoodieSetting);
        }
    }, [getFirstFoodieSetting]);


    // Set step labels using translations when permissions or translations change
    useLayoutEffect(() => {
        setSteps([t("set_up"), t("availability"), t("custom_restrictions"), t("summary")]);
    }, [permission, t]);

    // Validate required fields for the current step
    const handleStepSetUp = () => {
        let isEmpty = false;
        switch (activeStep) {
            case 0: {
                let notSelected = false;
                let notAdded = false;
                mealTime.validate({
                    setNotSelected: (value) => (notSelected = value),
                    setNotAdded: (value) => (notAdded = value),
                    selectedMealTime,
                });
                isEmpty = !item.isValidSetUp(showCostInfo) || !isValidCost || notSelected || notAdded;
                break;
            }

            case 1: {
                let notSelected = false;
                let notAdded = false;
                department.validate({
                    setNotSelected: (value) => (notSelected = value),
                    setNotAdded: (value) => (notAdded = value),
                    selectedDepartment,
                });
                isEmpty = !item.isValidAvailability() || !isServingDateValid || notSelected || notAdded;

                break;
            }

            default:
                isEmpty = false;
        }

        setEmptyFields((prev) => ({ ...prev, [activeStep]: isEmpty }));
        return !isEmpty;
    };

    useEffect(() => {
        department.validate({
            setNotSelected,
            setNotAdded,
            selectedDepartment,
        });
    }, [department, selectedDepartment]);
    useEffect(() => {
        mealTime.validate({
            setNotSelected,
            setNotAdded,
            selectedMealTime,
        });
    }, [mealTime, selectedMealTime]);

    // Re-validate fields when step dependencies change
    useEffect(() => {
        if (emptyFields[activeStep]) {
            handleStepSetUp();
        }
    }, stepDependencies[activeStep]);

    // Change the active step
    const handleStepChange = (step) => {
        setActiveStep(step);
    };

    // Create menu logic and submit form
    const handleCreate = () => {
        let aux = {
            ...item,
            releaseHour: toMilitaryHour(item.releaseHour),
            userIds: selectedUsers.map((item) => item.id),
            departments: selectedDepartment.map((dept) => ({
                departmentId: dept.id,
                availableAfterMinutes: parseInt(dept.time),
            })),
            foodieMealTimeIds: selectedMealTime.map((item) => ({
                mealTimeId: item.id,
                stock: item.unit,
            })),
        };

        // Convert to request body
        let body = aux.toRegister();
        dispatch(CreateMenu(body)).then(
            ({
                payload: {
                    data: { data, code },
                },
            }) => {
                if (data.id) {
                    toast.success(t('has_been_created_successfully'));
                    goBack();
                } else errorMsg(code);
            },
        );
    };

    /**
     * Handles navigation to the previous page or a default route.
     */
    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl.pathname, {
                state: {...state?.backUrl?.state}
            });
        } else {
            navigate(routes.foodie.list)
        }
    }

    return {
        t,
        item,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        handleCreate,
        handleStepChange,
        handleStepSetUp,
        emptyFields,
        handleChange,
        errorCode,
        allCourseType,
        setItem,
        allMeals,
        selectedMealTime,
        setSelectedMealTime,
        selectedDepartment,
        setSelectedDepartment,
        selectedUsers,
        setSelectedUsers,
        allItem,
        allCafeterias,
        goBack,
        costInfo,
        isServingDateValid,
        departments: getDepartmentsByCafeteriaId.map((i) => ({
            id: i.id,
            label: i.name,
            subtitle: 'after',
        })),
        users: getUsersByCafeteriaId.map((i) => ({
            id: i.id,
            label: i.name,
        })),
        mealTime: Array.isArray(allMealTimes)
            ? allMealTimes.map((i) => ({
                  id: i.id,
                  label: i.name,
                  subtitle: 'units',
              }))
            : [],

        notSelected,
        notAdded,
        setDepartment,
        isValidCost,
        isValidCostText,
        validateCost,
        setMealTime,
        showCostInfo
    };
};

export default CreateMenuApp;
